package com.cs.ejobin.vm

import com.cs.ejobin.app.AppSession
import com.cs.ejobin.data.SubscriptionRepository
import com.cs.ejobin.model.Subscription
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch

data class PaywallState(
    val isLoading: Boolean = false,
    val errorKey: String? = null
)

class PaywallViewModel(
    private val subs: SubscriptionRepository,
    private val session: AppSession
) : BaseViewModel() {

    private val _state = MutableStateFlow(PaywallState())
    val state: StateFlow<PaywallState> = _state.asStateFlow()

    /**
     * ✅ Paiement désactivé (temporaire)
     * On garde la signature et on ne casse rien côté UI/navigation.
     */
    fun start(plan: Subscription.Plan, onSuccess: () -> Unit) {
        _state.value = _state.value.copy(isLoading = true, errorKey = null)

        // ✅ On ne lance plus le checkout Stripe.
        // ✅ On continue juste le flow "comme si c'était OK".
        scope.launch {
            _state.value = _state.value.copy(isLoading = false, errorKey = null)
            onSuccess()
        }

        /*
        // 🔁 Ancienne logique (à réactiver plus tard)
        val userId = session.state.value.user?.id ?: return
        _state.value = _state.value.copy(isLoading = true, errorKey = null)
        scope.launch {
            runCatching {
                subs.startCheckout(userId, plan)
                val refreshed = subs.refreshSubscription(userId)
                session.updateSubscription(refreshed)
            }.onSuccess {
                _state.value = _state.value.copy(isLoading = false)
                onSuccess()
            }.onFailure { e ->
                _state.value = _state.value.copy(
                    isLoading = false,
                    errorKey = e.message ?: "Erreur paiement."
                )
            }
        }
        */
    }
}